export default {
      id: "investment-1-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#investment-1",
      toString: function () {
        return this.url;
      }
    }